import { useState, useEffect } from 'react';

const useCountUp = (end: number, shouldAnimate: boolean, duration: number = 1000) => {
  const [count, setCount] = useState(0);
  const DELAY_MS = 50;

  useEffect(() => {
    if (!shouldAnimate) {
      setCount(end);
      return;
    }

    let rafId: number;

    const timeoutId = setTimeout(() => {
      let startTime: number;

      const step = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        setCount(Math.floor(progress * end));

        if (progress < 1) {
          rafId = requestAnimationFrame(step);
        }
      };

      rafId = requestAnimationFrame(step);
    }, DELAY_MS); // Brief delay to prevent blocking initial render

    return () => {
      clearTimeout(timeoutId);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [end, duration, shouldAnimate]);

  return count;
};

export default useCountUp;
